<template>
  <div class="topbar">
    <div class="left">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="currentRoute.meta.title">
          {{ currentRoute.meta.title }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    
    <div class="right">
      <!-- 全屏按钮 -->
      <el-tooltip content="全屏" placement="bottom">
        <el-button
          class="action-btn"
          type="text"
          @click="toggleFullscreen"
        >
          <el-icon><FullScreen /></el-icon>
        </el-button>
      </el-tooltip>
      
      <!-- 用户信息 -->
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="user-info">
          <el-avatar :size="32" :src="adminInfo.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'" />
          <span class="username">{{ adminInfo.username || '管理员' }}</span>
          <el-icon><CaretBottom /></el-icon>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="profile">
              <el-icon><User /></el-icon>个人信息
            </el-dropdown-item>
            <el-dropdown-item command="logout">
              <el-icon><SwitchButton /></el-icon>退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessageBox, ElMessage } from 'element-plus'
import {
  FullScreen,
  CaretBottom,
  SwitchButton,
  User
} from '@element-plus/icons-vue'
import axios from 'axios'

const route = useRoute()
const router = useRouter()

const currentRoute = computed(() => route)
const adminInfo = ref({})

// 获取管理员信息
const getAdminInfo = () => {
  const admin = localStorage.getItem('admin')
  if (admin) {
    adminInfo.value = JSON.parse(admin)
  }
}

const toggleFullscreen = () => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen()
  } else {
    document.exitFullscreen()
  }
}

const handleCommand = async (command) => {
  if (command === 'profile') {
    router.push('/admin/profile')
  } else if (command === 'logout') {
    try {
      await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      
      // 清除本地存储的token和管理员信息
      localStorage.removeItem('adminToken')
      localStorage.removeItem('admin')
      
      // 清除axios默认请求头中的token
      delete axios.defaults.headers.common['Authorization']
      
      ElMessage.success('退出登录成功')
      
      // 跳转到登录页
      router.push('/admin/login')
    } catch (error) {
      // 用户取消操作
    }
  }
}

onMounted(() => {
  getAdminInfo()
})
</script>

<style scoped>
.topbar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  font-family: "FangSong", "Source Han Sans CN", sans-serif;
}

.left {
  display: flex;
  align-items: center;
}

:deep(.el-breadcrumb) {
  font-family: "STZhongsong", "SimSun", serif;
  font-size: 20px;
  line-height: 1.5;
}

:deep(.el-breadcrumb__item) {
  display: flex;
  align-items: center;
}

:deep(.el-breadcrumb__inner) {
  font-weight: 600;
  color: #0b0b0b;
}

:deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
  color: #374146;
  font-weight: 700;
}

:deep(.el-breadcrumb__separator) {
  margin: 0 8px;
  color: #131313;
  font-family: "FangSong", "Source Han Sans CN", sans-serif;
  font-size: 18px;
  font-weight: 300;
}

.right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.action-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1f2937;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.action-btn:hover {
  background: #f0f5ff;
  color: #409EFF;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.8);
}

.user-info:hover {
  background: #f0f5ff;
}

.username {
  font-family: "Source Han Serif CN", "SimSun", serif;
  font-size: 20px;
  color: #1f2937;
  font-weight: 500;
  line-height: 1.5;
}

:deep(.el-dropdown-menu) {
  padding: 8px 0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: "Source Han Serif CN", "SimSun", serif;
}

:deep(.el-dropdown-menu__item) {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 18px;
  line-height: 1.5;
  color: #1f2937;
  font-weight: 300;
}

:deep(.el-dropdown-menu__item:hover) {
  background: #f0f5ff;
  color: #409EFF;
}

:deep(.el-dropdown-menu__item .el-icon) {
  font-size: 18px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .topbar {
    padding: 0 16px;
  }
  
  .username {
    display: none;
  }
  
  :deep(.el-breadcrumb) {
    font-size: 18px;
  }
}
</style>